export const experience = [
    {
        id: 1,
        title: "Analista de Calidad Practicante",
        institution: "Scotiabank",
        institutionURL: `https://www.scotiabankchile.cl/`,
        description: `Practicante en el departamento de calidad de la información del área de finanzas. Donde estaba a cargo de le generacion de reporteria en base a consultas a bases de datos SQL SERVER, programacion de PLSQL y migracion de datos mendiante ETL.`,
        from: "Enero 2019",
        to: "Febrero 2019"
    },
    {
        id: 2,
        title: "Front End Developer",
        institution: "Rompecabeza Digital",
        institutionURL: `https://www.rompecabeza.cl/`,
        description: `Desarrollador de distintas landings pages y sitios web para clientes como Vitamina, Flex, Habitat, Kaufmann. Trabaje de la mano con el area de UX/UI para materializar los distintos disenos propuestos, haciendo uso de Javascript y SCSS como libreria para CSS.`,
        from: "Mayo 2020",
        to: "Marzo 2021"
    },
    {
        id: 3,
        title: "Customer Excellence",
        institution: "VTEX Chile",
        institutionURL: `https://www.vtex.com/`,
        description: `Encargado de entregar soporte de la plataforma VTEX a distintos clientes y agencias implementadoras. Enfocado en el Front End y VTEX IO, Framework de desarrollo para las tiendas compuesto por tecnologias como React, NodeJS, GraphQL.
        Creador de una de las primeras APPS en VTEX IO por VTEX Chile`,
        from: "Marzo 2021",
        to: "Abril 2022"
    },
    {
        id: 4,
        title: "Front End Engineer",
        institution: "Autocred",
        institutionURL: `https://www.autocred.cl/`,
        description: `Proyecto realizado en 3 meses, en donde fui encargado de proponer la arquitectura que se utilizaria en el front-end, coordinar con el equipo de backend para desarrollar las API que se requerian para el correcto funcionamiento del sitio y el desarrollo completo de este basado en una arquitectura headless. El proyecto fue realizado haciendo uso de VUE 3, Nuxt 3, Tailwind, Pinia`,
        from: "Abril 2022",
        to: "Junio 2022"
    },
    {
        id: 5,
        title: "Front End Developer",
        institution: "BBK+2Brains",
        institutionURL: `https://www.bbk2brains.com/`,
        description: `Desarrollador para cliente Banco de Chile. Encargado de llevar a cabo la migración a plataforma Modyo 9, dentro de mis tareas esta la creacion de componentes para replicar lo que existe actualmente en el sitio publico. Ademas he creado distintos proyectos para ayudar al equipo, entre los que se encuentran: Comando npx para la creacion de proyectos con la base a utilizarse - Proyecto para generacion de documentacion basado en Markdown - Landing con libreria de iconos del sitio, con su respectivo buscador y click and copy - Packages npm con configuraciones tailwind - Proyecto Base con componentes genericos del sitio`,
        from: "Junio 2022",
        to: "Actualidad"
    }
]
